'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

type DeviceType = 'mobile' | 'desktop' | null;

interface DeviceContextType {
  deviceType: DeviceType;
  isMobile: boolean;
  isDesktop: boolean;
}

const DeviceContext = createContext<DeviceContextType | undefined>(undefined);

export function DeviceProvider({ children }: { children: React.ReactNode }) {
  const [deviceType, setDeviceType] = useState<DeviceType>(null);

  useEffect(() => {
    const detectDevice = () => {
      if (typeof window !== 'undefined') {
        const screenWidth = window.innerWidth;
        const isMobile = screenWidth < 768; // Align with app/layout.tsx, use tailwind breakpoint 768px
        const newDeviceType = isMobile ? 'mobile' : 'desktop';
        
        setDeviceType(newDeviceType);
        console.log(`Device Detection: ${newDeviceType} (screen width: ${screenWidth}px)`);
      }
    };

    // Detect on mount
    detectDevice();

    // Listen for window resize
    window.addEventListener('resize', detectDevice);

    // Cleanup
    return () => {
      window.removeEventListener('resize', detectDevice);
    };
  }, []);

  const value = {
    deviceType,
    isMobile: deviceType === 'mobile',
    isDesktop: deviceType === 'desktop'
  };

  return (
    <DeviceContext.Provider value={value}>
      {children}
    </DeviceContext.Provider>
  );
}

export function useDevice() {
  const context = useContext(DeviceContext);
  if (context === undefined) {
    throw new Error('useDevice must be used within a DeviceProvider');
  }
  return context;
} 